import React, { ReactNode } from 'react'

import { Container, ContainerProps } from './styles'

type Props = ContainerProps & {
  children: ReactNode
}

function PageWrapper({ children, ...rest }: Props) {
  return <Container {...rest}>{children}</Container>
}

export default PageWrapper
